/**
 * API Configuration
 * All requests use API_BASE + path, e.g. API_BASE + '/api/blog'.
 * So API_BASE must be the origin only (e.g. https://drnuha.com), never include /api.
 */

const getApiBase = () => {
  const raw = process.env.REACT_APP_API_URL;
  if (raw !== undefined && raw !== null && String(raw).trim() !== '') {
    let url = String(raw).trim().replace(/\/$/, '');
    // Strip trailing /api so we never get double /api (e.g. .../api/api/blog)
    if (url.endsWith('/api')) url = url.slice(0, -4);
    return url;
  }
  if (process.env.NODE_ENV === 'production') {
    return ''; // same origin
  }
  return 'http://localhost:5000';
};

export const API_BASE = getApiBase();

// Log API configuration (always, for debugging)
console.log('API Configuration:', {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  NODE_ENV: process.env.NODE_ENV,
  API_BASE: API_BASE,
  window_location: typeof window !== 'undefined' ? window.location.origin : 'N/A'
});
